import { rankWith, isMultiLineControl } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { FormItem } from '../../../../../controls/FormItem';
import { Textarea } from '../../../../../controls/Textarea';
import { FieldProps, WithDynamicFormContext } from '../WithDynamicFormContext';
import './style.scss';

const TextareaControl = ({
  path,
  label,
  handleChange,
  handleRemove,
  handleBlur,
  data,
  required,
  schema,
  uischema,
  disabled,
  optionalMessage,
}: FieldProps) => {
  const moreInfo = uischema.options?.moreInfo;

  return (
    <FormItem
      label={label as string}
      required={required}
      classes="tru-textarea-input-control"
      moreInfo={moreInfo}
      optionalMessage={optionalMessage}
    >
      <div>
        <Textarea
          onBlur={() => handleBlur(path)}
          value={data || ''}
          onChange={(value) => {
            if (!!value) {
              handleChange(path, value);
            } else {
              handleRemove(path);
            }
          }}
          disabled={disabled}
        />
        {schema.description && (
          <p className="description margin-bottom">{schema.description}</p>
        )}
      </div>
    </FormItem>
  );
};

export const TextareaInputControlEntry = {
  tester: rankWith(3, isMultiLineControl),
  renderer: withJsonFormsControlProps(WithDynamicFormContext(TextareaControl)),
};
